import { FetchPdfium } from "../../files/FetchPdfium"
import { GenerateFile } from "../../files/GenerateFile"
import { RectangleFromArray } from "../../geometry/RectangleFromArray"
import type { PdfEngine } from "../../types/engine/PdfEngine"
import { ContentType } from "../../types/files/ContentType"
import { VirtualFileType } from "../../types/files/VirtualFileType"
import type { TaskResult } from "../../types/tasks/input/TaskResult"
import type { TaskSplitOptions } from "../../types/tasks/options/TaskSplitOptions"
import { TaskName } from "../../types/tasks/TaskName"
import { TrackedTaskName } from "../../types/tasks/tracking/TrackedTaskName"
import type { TrackingCallback } from "../../types/tasks/tracking/TrackingCallback"

// options SplitPdfOptions file: GeneratedFile
// stream - no
// emit TrackingCallback
//
// return DocumentPage[1, GeneratedFile[...]]

export async function* TaskSplit(
  engine: PdfEngine,
  task: TaskSplitOptions,
  emit: TrackingCallback
): AsyncGenerator<TaskResult> {
  const document = await FetchPdfium(engine, task.options, task.source, emit)

  void emit({
    name: TrackedTaskName.SPLIT_PDF,
    done: 0,
    total: document.page_count,
  })

  try {
    // Then yield each page as a separate PDF
    for await (const page_number of document.iterate_pages()) {
      const { blob, trim_box, media_box } =
        await document.extract_page_as_pdf(page_number)

      const content = await GenerateFile(engine, [blob], ContentType.PDF)

      yield {
        enum: TaskName.CONTENT_FILE,
        name: `${page_number}.pdf`,
        content: {
          enum: VirtualFileType.SINGLE_PAGE_PDF,
          content,
          source: task.source,
          page: undefined,
          context: undefined,
          file_meta: {},
          page_number,
          page_count: document.page_count,
          trim_box: RectangleFromArray(task.options, trim_box),
          media_box: RectangleFromArray(task.options, media_box),
        },
      }

      void emit({
        name: TrackedTaskName.SPLIT_PDF,
        done: page_number,
        total: document.page_count,
      })
    }
  } finally {
    await document.close()
  }
}
